<template>
  <div
    class="modal fade"
    id="paymentMethodRequiredModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="paymentMethodRequiredModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 payment-setup-shell">
        <div class="modal-body payment-setup-body">
          <header class="payment-setup-header">
            <div class="payment-setup-icon" aria-hidden="true">
              <i class="material-icons">account_balance_wallet</i>
            </div>
            <div class="payment-setup-heading">
              <h2
                id="paymentMethodRequiredModalLabel"
                class="payment-setup-title"
              >
                Configure seu método de pagamento
              </h2>
              <p class="payment-setup-subtitle">
                Assista o vídeo e finalize a configuração para começar a receber
                nas suas campanhas.
              </p>
            </div>
          </header>

          <div class="payment-setup-video">
            <div class="payment-setup-video-frame">
              <iframe
                v-if="youtubeEmbedUrl"
                :src="youtubeEmbedUrl"
                title="Como configurar o método de pagamento"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
              ></iframe>
              <div v-else class="payment-setup-video-placeholder">
                <i class="material-icons">play_circle</i>
                <span>Vídeo explicativo</span>
              </div>
            </div>
          </div>

          <ul class="payment-setup-checklist">
            <li>
              <i class="material-icons">check_circle</i>
              Recebimento automático via Pix
            </li>
            <li>
              <i class="material-icons">check_circle</i>
              Liberação automática das vendas
            </li>
            <li>
              <i class="material-icons">check_circle</i>
              Ambiente seguro nas transações
            </li>
          </ul>

          <p class="payment-setup-note">
            Ao continuar, você será direcionado para a aba de métodos de
            pagamento nas configurações.
          </p>

          <div class="payment-setup-cta">
            <button
              type="button"
              class="btn payment-setup-button"
              @click="goToSettings"
            >
              Configurar método de pagamento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

// Cole aqui o ID do vídeo do YouTube (ex: "dQw4w9WgXcQ" ou o link completo)
const YOUTUBE_VIDEO_ID = "NdgrBYicOw4";

export default {
  name: "PaymentMethodRequiredModal",
  emits: ["close"],
  data() {
    return {
      modalInstance: null,
      isNavigating: false,
      youtubeVideoId: this.extractYoutubeId(YOUTUBE_VIDEO_ID),
    };
  },
  computed: {
    youtubeEmbedUrl() {
      if (!this.youtubeVideoId) return "";
      // mute=1 é necessário: navegadores bloqueiam autoplay com som
      return `https://www.youtube.com/embed/${this.youtubeVideoId}?autoplay=1&mute=1&rel=0&modestbranding=1&playsinline=1`;
    },
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal, {
      backdrop: "static",
      keyboard: false,
    });
    this.modalInstance.show();
  },
  beforeUnmount() {
    this.cleanupBootstrapModal();
  },
  methods: {
    extractYoutubeId(value) {
      const raw = String(value || "").trim();
      if (!raw) return "";

      const match = raw.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|shorts\/|watch\?v=|watch\?.+&v=))([\w-]{11})/
      );
      if (match?.[1]) return match[1];

      return /^[\w-]{11}$/.test(raw) ? raw : "";
    },
    cleanupBootstrapModal() {
      try {
        this.modalInstance?.dispose();
      } catch (_) {
        // already disposed
      }
      this.modalInstance = null;

      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    },
    finishAndGoToSettings() {
      this.cleanupBootstrapModal();
      this.$emit("close");
      this.$router.push({
        name: "Configurações",
        query: { tab: "payment_methods" },
      });
    },
    goToSettings() {
      if (this.isNavigating) return;
      this.isNavigating = true;

      const el = this.$refs.modal;
      if (!el || !this.modalInstance) {
        this.finishAndGoToSettings();
        return;
      }

      const onHidden = () => {
        el.removeEventListener("hidden.bs.modal", onHidden);
        this.finishAndGoToSettings();
      };

      el.addEventListener("hidden.bs.modal", onHidden);
      this.modalInstance.hide();
    },
  },
};
</script>

<style scoped>
.payment-setup-shell {
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18);
  animation: paymentSetupIn 0.28s ease-out;
}

.payment-setup-body {
  padding: 1.5rem 1.35rem 1.35rem;
  max-height: min(90vh, 820px);
  overflow-x: hidden;
  overflow-y: auto;
}

.payment-setup-header {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 1.15rem;
}

.payment-setup-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3e8ff;
  color: #6b21a8;
}

.payment-setup-icon .material-icons {
  font-size: 1.35rem;
}

.payment-setup-heading {
  min-width: 0;
  padding-top: 0.1rem;
}

.payment-setup-title {
  margin: 0 0 0.2rem;
  color: #1f2937;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.payment-setup-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 0.88rem;
  line-height: 1.45;
}

.payment-setup-video {
  margin-bottom: 1rem;
}

.payment-setup-video-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 14px;
  background: #0f172a;
  border: 1px solid #e5e7eb;
}

.payment-setup-video-frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.payment-setup-video-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  color: rgba(255, 255, 255, 0.78);
  background: linear-gradient(160deg, #4c1d95 0%, #1e1b4b 100%);
}

.payment-setup-video-placeholder .material-icons {
  font-size: 2.75rem;
  opacity: 0.9;
}

.payment-setup-video-placeholder span {
  font-size: 0.9rem;
  font-weight: 600;
}

.payment-setup-checklist {
  list-style: none;
  margin: 0 0 0.9rem;
  padding: 0;
  display: grid;
  gap: 0.55rem;
}

.payment-setup-checklist li {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: #374151;
  font-size: 0.88rem;
  font-weight: 500;
}

.payment-setup-checklist .material-icons {
  color: #7c3aed;
  font-size: 1.1rem;
}

.payment-setup-note {
  margin: 0 0 1.1rem;
  color: #9ca3af;
  font-size: 0.8rem;
  line-height: 1.45;
}

.payment-setup-cta {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.payment-setup-button {
  width: 100%;
  margin: 0;
  padding: 0.9rem 1rem;
  border: none;
  border-radius: 12px;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.98rem;
  background: #6b21a8 !important;
  box-shadow: none;
  transition: filter 0.2s ease, transform 0.2s ease;
}

.payment-setup-button:hover {
  color: #fff !important;
  filter: brightness(1.06);
  transform: translateY(-1px);
}

.payment-setup-button:active {
  transform: translateY(0);
}

@keyframes paymentSetupIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 575.98px) {
  .payment-setup-body {
    padding: 1.25rem 1.05rem 1.1rem;
  }

  .payment-setup-title {
    font-size: 1.05rem;
  }

  .payment-setup-subtitle {
    font-size: 0.84rem;
  }
}
</style>
